import { render, staticRenderFns } from "./ModalConsultarCarona.vue?vue&type=template&id=f3027bf0"
import script from "./ModalConsultarCarona.vue?vue&type=script&lang=js"
export * from "./ModalConsultarCarona.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports